<div class="modal-content">
  <div class="modal-header text-center">
    <span class="modal-multiplos-enderecos__title">Escolha o endereço</span>
  </div>
  <form class="modal-body text-center" [formGroup]="formMultiplosEnderecos">
    <section>
      <div class="modal-multiplos-enderecos__text">
        <span *ngIf="!isBuscaPorEndereco">O CEP digitado possui mais de um endereço.<br></span>
        <span *ngIf="isBuscaPorEndereco">Encontramos mais de um endereço.<br></span>
        <span>Selecione o endereço desejado:</span>
      </div>
      <section class="modal-multiplos-enderecos__list">
        <div 
          class="modal-multiplos-enderecos__option" 
          [ngClass]="{'modal-multiplos-enderecos__option_checked': endereco.bairro === enderecos.bairro && endereco.cep === enderecos.cep}"
          (click)="onChangeEndereco(endereco)" 
          *ngFor="let endereco of listaEnderecos">
          <div class="modal-multiplos-enderecos__option_text">
            <label [for]="endereco.id">
              {{ endereco.cep }}
            </label>
            <span>
            {{ getTipoLogradouro(endereco.tipo, endereco.endereco) }} {{ endereco.bairro }}, {{ endereco.cidade}} - {{ endereco.uf}}
            </span>
          </div>
          <input
            type="radio"
            formControlName="enderecos"
            [id]="endereco"
            [value]="endereco" />
        </div>
      </section>
    </section>
  </form>

  <div class="modal-footer">
    <div class="modal-multiplos-enderecos__action">
      <button 
        type="button" 
        class="btn btn-app btn-secondary" 
        (click)="close()">
        Cancelar
      </button>
      
      <button 
        type="button" 
        class="btn btn-app btn-primary" 
        [disabled]="!formValid" 
        (click)="onClickConfirmar()">
        Confirmar
      </button>
    </div>
  </div>
</div>